业务准入产品流水列表
@zhaoyr
<template>
  <div class="bizList-outer flex flex-middle flex-center">
    <p class="title">{{propData.title}}</p>
    <el-main>
      <el-table class="bizList-table" :data="propData.bizList" width="100%" height="560">
        <el-table-column prop="B_SNO" label="业务单号" width="300"></el-table-column>
        <el-table-column prop="ORG_FULL_NAME" label="受理机构全称" width="400"></el-table-column>
        <el-table-column prop="PROC_STATUS" label="当前步骤" :formatter="formatterProcStatus" width="172"></el-table-column>
        <el-table-column label="操作" width="170" className="actionList">
          <template slot-scope="scope">
            <div class="btn-box">
              <el-button type="text" round @click="clickItem(scope.$index)">{{propData.dealButtonTxt}}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </div>
</template>

<script>
import dict from "@/tools/dict";

export default {
  async created () {
    this.dictObj = await dict.getDictData("PROC_STATUS");
  },
  data () {
    return {
      dictObj: []
    };
  },
  props: {
    propData: {
      type: Object,
      default: {}
    }
  },
  methods: {
    formatterProcStatus (row, column) {
      //“当前步骤”字段已完结或作废状态的业务，可显示为已完成/作废，流程未完结的时候显示与受理待办列表数据一致
      let tname = ["11", "13", "15"].includes(row.PROC_STATUS) ? "" : row.TNAME; //TNAME为空不匹配，直接翻译字典项
      return tname || dict.getDictText(row.PROC_STATUS, this.dictObj["PROC_STATUS"] || []);
    },
    clickItem (bizIndex) {
      this.$emit("saveAndAction", [{ bizIndex: bizIndex }, "confirm"]);
    }
  }
};
</script>

<style lang="less" scoped>
.bizList-outer {
  flex-direction: column;
  padding: 80px 0;
  .title {
    font-size: 40px;
    font-weight: bold;
    line-height: 52px;
    color: #232323;
  }
  .el-main {
    margin-top: 20px;
    /deep/ .bizList-table {
      flex: 1;
      max-width: 100%;
      overflow: auto;

      &.el-table {
        border: 2px solid #cfd3e1;
        border-radius: 4px;

        .el-table__header {
          th {
            background: #f0f3f8;
          }
        }

        td,
        th {
          border-width: 2px;
          border-color: #ced2e1;

          .cell {
            padding: 0 30px;
            font-size: 20px;
            font-weight: 500;
            line-height: 30px;
            color: #232323;
            text-align: center;
          }
        }

        th {
          .cell {
            color: #808992;
          }
        }

        thead tr {
          height: 55px;
        }

        tbody {
          tr {
            height: 112px;

            td.actionList .cell .btn-box {
              display: flex;
              flex-direction: column;
              align-items: center;

              .el-button {
                width: 110px;
                height: auto;
                font-size: 22px;
                font-weight: 700;
                color: #fff;
                letter-spacing: 2px;
              }

              .el-button + .el-button {
                margin: 0;
              }

              > span {
                align-self: flex-start;
                margin-left: -20px;
              }
            }
          }
        }

        .el-table__empty-block {
          font-size: 32px;
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/lib/ui/default/popup/src/content/proBizList.vue